<template>
  <div class="loading-modal">
    <div class="loading-spinner" />
  </div>
</template>
